var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('head-vue'),_c('bannerVue'),_c('navVue'),_c('div',{staticClass:"main"},[_c('router-view')],1),_c('foot-vue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }